import { useState, useEffect, useRef, useContext } from "react"
import { WhichWeightAPI } from "WhichWeightAPI"
import { ModalContext, ModalKey } from 'components/Modals/ModalContext'
import { useSelector } from "react-redux"
import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
// import { ExclamationTriangleIcon, InformationCircleIcon } from '@heroicons/react/24/outline'

import PaymentMethod from 'components/Billing/PaymentMethod'
import BrandColorButton from "components/Buttons/BrandColorButton"

export default function OrganizationPaymentMethod({
    billingData
}) {
    const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY)

    const paymentMethodRef = useRef(null);

    const { ShowModal } = useContext(ModalContext)

    const organizationId = useSelector((state) => state.user.organizationId)
    // const requirePaymentMethodToInviteAthletes = useSelector((state) => state.user.requirePaymentMethodToInviteAthletes)

    const [paymentMethodDisplayState, setPaymentMethodDisplayState] = useState(null)
    const [isSavingPaymentMethod, setIsSavingPaymentMethod] = useState(false);
    const [showErrorModal, setShowErrorModal] = useState(false);

    const SavePaymentMethod = async () => {
        setShowErrorModal(false);
        setIsSavingPaymentMethod(true);

        // Debugging for error modal
        // await new Promise(resolve => setTimeout(resolve, 1000));
        // setIsSavingPaymentMethod(false);
        // setShowErrorModal(true)
        // return

        const submittedPaymentMethod = await paymentMethodRef.current.SubmitPaymentMethod()

        if (submittedPaymentMethod === null) {
            setIsSavingPaymentMethod(false);
            setShowErrorModal(true);
            return;
        }

        const jsonBody = {
            organizationId: organizationId,
            paymentMethodId: submittedPaymentMethod.id
        }

        // console.log(jsonBody);

        const response = await WhichWeightAPI("BILLING", 'POST', '/attach_payment_method_to_organization', jsonBody)

        // console.log(response);

        if (response.data.status === 'failure') {
            setIsSavingPaymentMethod(false);
            setShowErrorModal(true);
            console.error(response);
            return;
        }

        setIsSavingPaymentMethod(false);

        window.location.reload();
    }

    const ShowErrorModal = () => {
        const modalData = {
            key: ModalKey.ActionWarning,
            fullscreen: false,
            size: 'quarter',
            titleText: 'Error Saving Payment Method',
            bodyText: [
                'Failed to save payment method. Please try again.',
                'If the problem persists, please contact support@kinesisintegrated.com'
            ],
            buttonText: 'Close',
            buttonAction: () => {}
        }

        ShowModal(modalData)
    }

    useEffect(() => {

        // If we are missing stripe data, default to input mode
        if (
            billingData.organizationBillingInfo.adminStripeCustomerId === '' 
            || billingData.organizationStripeData.paymentMethod === null
            || billingData.organizationStripeData.paymentMethod.type !== 'card'
        ) {
            setPaymentMethodDisplayState('input')
        }

        // If we have stripe data, default to display mode
        if (
            billingData.organizationBillingInfo.adminStripeCustomerId !== '' 
            && billingData.organizationStripeData.paymentMethod !== null
            && billingData.organizationStripeData.paymentMethod.type === 'card'
        ) {
            setPaymentMethodDisplayState('display')
        }

    }, [billingData])
    
    useEffect(() => {
        if (showErrorModal === true) {
            ShowErrorModal()
        }
    }, [showErrorModal])

    if (paymentMethodDisplayState === null) return null

    return (
        <div 
            className="p-4 flex items-center"
        >
            <div className="pr-2">Payment Method</div>

            {/* 
            {paymentMethodDisplayState === 'input' && requirePaymentMethodToInviteAthletes === 1 && 
                <>
                    <ExclamationTriangleIcon className="mt-0.5 h-4 w-4 text-yellow-500 mr-1" />

                    <div className="text-xs text-yellow-500 font-bold rounded-full py-1">
                        Required to add athletes!
                    </div>
                </>
            } 
            */}

            <div className="flex-1"/>

            {paymentMethodDisplayState === 'input' &&
                <>
                    <div className="w-1/2 pr-4">
                        <Elements stripe={stripePromise}>
                            <PaymentMethod ref={paymentMethodRef} />
                        </Elements>
                    </div>

                    <div className="w-24 -my-1">
                        <BrandColorButton
                            size="extra-small"
                            text="Save"
                            isLoading={isSavingPaymentMethod}
                            action={() => SavePaymentMethod()}
                        />
                    </div>

                    {/* <InformationCircleIcon className="ml-3 mr-1 h-6 w-6 text-gray-500" /> */}
                </>
            }

            {paymentMethodDisplayState === 'display' &&
                <>
                    <div className="pr-4">
                        {billingData.organizationStripeData.paymentMethod.card.brand.toUpperCase()} card ending in {billingData.organizationStripeData.paymentMethod.card.last4}
                    </div>
                       
                    <div className="w-24 -my-1">
                        <BrandColorButton
                            size="extra-small"
                            text="Edit"
                            action={() => setPaymentMethodDisplayState('input')}
                        />
                    </div>

                    {/* <InformationCircleIcon className="ml-3 mr-1 h-6 w-6 text-gray-500" /> */}
                </>
            }
        </div>
    )
}